import { gql } from '__generated__';

export const GET_USERS = gql(/* GraphQL */ `
  query getUsers($usersInput: UsersInput!) {
    users(usersInput: $usersInput) {
      ...UserOption
      id
      firstName
      lastName
      email
      phoneNumber
      isActive
    }
  }
`);
